<div
  *ngIf="showBanner"
  class="cookie-banner"
  [ngClass]="{ 'cookie-banner-hide': hidingBanner }"
>
  <span class="material-icons lock-icon">lock</span>
  <span>
    Este site utiliza cookies para oferecer uma melhor experiência ao usuário.
    Para uma visão completa de todos os cookies utilizados, leia nossa
    <a [href]="assetBaseUrl + 'Termos+de+Uso+e+Política+de+Privacidade.pdf'" target="_blank" title="Política de Cookies"><b>política de cookies</b></a
    >.
  </span>
  <button (click)="onAccept()" title="Aceitar cookies">ACEITAR</button>
</div>
